"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnackbarPM = void 0;
class SnackbarPM {
    dispose() {
        this.snackbarRepo.removeObserver(this.doUpdateView);
    }
    constructor(snackbarUC, updateView) {
        this.doUpdateView = (snackbar) => {
            let model = {
                message: undefined,
                durationInSeconds: 0,
                actionButtonText: undefined
            };
            if (snackbar) {
                model = {
                    message: snackbar.message,
                    durationInSeconds: snackbar.durationInSeconds,
                    actionButtonText: snackbar.snackbarAction ? snackbar.snackbarAction.actionButtonText : undefined
                };
            }
            this.updateView(model);
        };
        this.snackbarRepo = snackbarUC;
        this.updateView = updateView;
        this.doUpdateView(undefined);
        this.snackbarRepo.addObserver(this.doUpdateView);
    }
}
exports.SnackbarPM = SnackbarPM;
